import DeviceId from 'utils/detectDevice'

function getSelectedPostedBy(value) {
  return DeviceId.isMobile() ? value : value.value
}

export default getSelectedPostedBy
